export default {
  admins: {
    name: '',
    fields: {
      searchable: 'ชื่อ',
      user_id: 'รหัสผู้ใช้งาน',
      username: 'Username',
      name: 'ชื่อจริง',
      firstname_th: 'ชื่อ',
      lastname_th: 'นามสกุล',
      firstname_en: 'Name',
      lastname_en: 'Lastname',
      email: 'อีเมล',
      phone: 'หมายเลขโทรศัพท์',
      status: 'สถานะ',
      create_at: 'วันที่สร้าง',
      create_by: 'คนที่สร้าง',
      update_at: 'วันที่อัพเดต',
      update_by: 'คนที่อัพเดต',
      last_login: 'วันที่ใช้งานล่าสุด',
      roles: 'บทบาท',
      role: 'บทบาท',
      password: 'รหัสผ่าน',
      current_password: 'รหัสผ่านปัจจุบัน',
      new_password: 'รหัสผ่านใหม่',
      confirm_password: 'ยืนยันรหัสผ่าน',
      access_level: {
        label: 'ระดับการเข้าถึง',
        choices: { all_branches: 'ทุกสาขา', some_branches: 'เฉพาะสาขา' },
      },
      password_conditions:
        'ต้องมีอักษรตัวพิมพ์ใหญ่และตัวพิมพ์เล็ก (A-z) ตัวเลข (0-9) อย่างน้อยหนึ่งตัว และต้องมีอย่างน้อย 8 ตัวอักษร',
    },
    create: { title: 'สร้าง Admin' },
    edit: { title: 'แก้ไข Admin' },
    show: { title: 'รายละเอียด Admin' },
  },
}
